export const EHsaType = {
  FAMILY: "family",
  INDIVIDUAL: "individual",
} as const;

export type EHsaType = (typeof EHsaType)[keyof typeof EHsaType];

export const EHsaTypeMembers = Object.values(EHsaType);
